exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sku_title[data-v-c9401ff0]{overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:1;word-break:break-word}.sku_tags[data-v-c9401ff0]{display:inline-block;margin-top:5px}", ""]);

// exports
